import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

export function initUpsellSwiper() {
  if (!document.querySelector('.js-swiper-upsell')) {
    return
  }

  new Swiper('.js-swiper-upsell', {
    autoplay: {
      delay: 3000,
    },
    loop: true,
    spaceBetween: 20,
  })
}
